'use client';
import { useEffect } from 'react';
 import Header from'@/components/common/Header';
 import Footer from'@/components/common/Footer';
 import BioSection from'./components/BioSection';
 import ExperienceSection from'./components/ExperienceSection';
 import ApproachSection from'./components/ApproachSection';
 import BTSSection from'./components/BTSSection';
 import Link from'next/link';

export default function AboutPage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return

    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach((el) => observer?.observe(el))

    return () => observer?.disconnect();
  }, [])

  return (
    <>
      <Header />
      <main className="min-h-screen bg-background pt-32 pb-24 px-6">
        <div className="max-w-7xl mx-auto">
          {/* Page Header */}
          <div className="text-center mb-16 reveal">
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-4 tracking-tight">
              Meet the Photographer
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Passionate about capturing authentic moments
            </p>
          </div>

          {/* Bio Section */}
          <BioSection />

          {/* Experience Section */}
          <ExperienceSection />

          {/* Approach Section */}
          <ApproachSection />

          {/* BTS Section */}
          <BTSSection />

          {/* CTA */}
          <div className="text-center mt-16 pt-16 border-t border-border reveal">
            <h3 className="text-3xl font-bold text-white mb-4">
              Ready to Work Together?
            </h3>
            <p className="text-muted-foreground mb-8 max-w-xl mx-auto">
              Let's create something beautiful. Get in touch to discuss your
              photography needs.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link
                href="/gallery"
                className="px-8 py-4 border border-white/20 rounded-lg font-medium text-white hover:bg-white hover:text-background transition-all duration-300"
              >
                View Portfolio
              </Link>
              <Link
                href="/homepage#contact"
                className="px-8 py-4 bg-white text-background rounded-lg font-medium hover:bg-white/90 transition-all duration-300"
              >
                Book a Session
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  )
}